import React from 'react';

type LanguageContext = {
  language: string | null,
  translations: any | null,
  updateTranslations: Function
}

export default React.createContext<LanguageContext>({
  language: '',
  translations: {},
  updateTranslations: () => {console.warn("updateTranslations called without a provider")}
});
